export default __webpack_public_path__ + "static/media/1908.88d1fb5d.png";